import { useTranslation } from 'react-i18next'
import cn from 'classnames'

import { Typography } from '@/UI-KIT/Typography/Typography'

import { NETWORK_STATS, ROLE_ROWS } from './networkRoles'
import styles from './NetworkSection.module.scss'

/**
 * Answers the first question a buyer has after the hero — is there anyone in here, and are they the
 * people who decide — by showing rather than claiming.
 *
 * It replaced a section that named the problem a third time. Naming the problem sells the problem;
 * the measured network sells the product. Every number carries its provenance in `networkRoles.ts`,
 * including the date it was measured and when it is due to be rechecked.
 */
export const NetworkSection = () => {
  const { t } = useTranslation()

  return (
    <section id="network" className={styles.root}>
      <div className={styles.card}>
        <p className={styles.eyebrow}>{t('landing.network.eyebrow')}</p>
        <Typography variant="h2" color="heading" className={styles.title}>
          {t('landing.network.title')}
        </Typography>

        <div className={styles.stats}>
          {NETWORK_STATS.map((stat) => (
            <div key={stat.key} className={styles.stat}>
              <p className={styles.number}>{stat.value}</p>
              <p className={styles.label}>{t(`landing.network.stats.${stat.key}`)}</p>
            </div>
          ))}
        </div>

        {/* Decorative by intent: the role names are texture, so the wall is one image to a screen
            reader and the duplicated half that makes the drift seamless is hidden from it. */}
        <div className={styles.wall} role="img" aria-label={t('landing.network.wallLabel')}>
          {ROLE_ROWS.map((roles, index) => (
            <div key={index} className={cn(styles.row, styles[`row-${index + 1}`])}>
              {roles.map((role) => (
                <span key={role.label} className={cn(styles.role, { [styles.senior as string]: role.senior })}>
                  {role.label}
                </span>
              ))}
              {roles.map((role) => (
                <span
                  key={`echo-${role.label}`}
                  className={cn(styles.role, styles.echo, { [styles.senior as string]: role.senior })}
                  aria-hidden="true"
                >
                  {role.label}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
